import layout from '@/layout'

export default {
  path: '/rzrq',
  component: layout,
  redirect: '/rzrq/index',
  name: 'rzrqIndex',
  meta: {
    title: 'rzrq',
    icon: 'rzrq'
  },
  children: [
    {
      path: '/rzrq/index',
      name: 'rzrqIndex',
      component: () => import('@/views/rzrq/index'),
      meta: {
        title: 'rzrqIndex',
        icon: 'rzrq'
      }
    },
    {
      path: '/rzrq/mark',
      name: 'rzrqMark',
      component: () => import('@/views/rzrq/mark'),
      meta: {
        title: 'rzrqMark',
        icon: 'rzrq'
      }
    }
  ]
}
